import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Box from 'components/Box'
import Heading from 'components/Heading'
import { space } from 'styled-system'
import { captionStyles } from 'components/Caption'

export const RowGroup = props => <Box {...props} role="rowgroup" />

export const Row = styled(Box).attrs({
  display: ['block', 'flex'],
  justifyContent: 'space-between',
  flexWrap: 'nowrap',
  pt: 4,
  pb: 4,
  role: 'row',
  position: 'relative',
})`
  & + & {
    border-top: 1px solid ${({ theme }) => theme.colors.border.dark.high};
  }

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`

export const Cell = styled(Box).attrs(({ width }) => {
  return {
    role: 'cell',
    ml: [0, 6],
    width: width || '100%',
  }
})`
  &:first-child {
    margin-left: 0;
  }
`

export const HeadingCell = ({ children, ...props }) => (
  <Cell {...props}>
    <Heading.H5 m={0} mt={[0, 2]}>
      {children}
    </Heading.H5>
  </Cell>
)
HeadingCell.propTypes = {
  children: PropTypes.node,
}

const Caption = styled.div`
  ${space}
  ${captionStyles}
  line-height: 1.5;
`

export const CaptionCell = ({ children, ...props }) => (
  <Cell {...props}>
    <Caption m={0} mt={[0, 2]}>
      {children}
    </Caption>
  </Cell>
)
CaptionCell.propTypes = {
  children: PropTypes.node,
}

export const panelActionCellProps = {
  position: ['absolute', 'static'],
  right: 0,
  top: 0,
  width: ['30%', 'auto'],
  height: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
}

export default RowGroup
